const Modal = ({ setModalOn, currentLang, setCurrentLang }) => {
  const handleOKClick = () => {
    setModalOn(false);
  };

  return (
    <div className="fixed top-0 flex items-center justify-center left-0  w-full bottom-0 bg-opacity-60 bg-black z-[999]">
      <div className="bg-white px-12 py-12 rounded-lg max-w-xl z-50 relative m-4">
        <div className="flex flex-col text-black mb-10 text-center space-y-5">
          <h2 className="font-bold text-2xl">
            {currentLang === "eng" ? "Announcement" : "Duyuru"}
          </h2>
          <h3 className="text-xl">
            {currentLang === "eng" ? (
              <>
                Applications are over.
                <br />
                Thank you for your interest!
              </>
            ) : (
              <>
                Başvurular sona erdi.
                <br />
                İlginiz için teşekkürler!
              </>
            )}
          </h3>
        </div>
        <div className="flex justify-center">
          <button
            onClick={handleOKClick}
            // href={currentLang === "eng" ? "/#register" : "/#basvur"}
            className="rounded px-4 py-2 border-2 border-blue-900 bg-blue-900 text-white hover:shadow-lg"
          >
            {currentLang === "eng" ? "Close" : "Kapat"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Modal;
